import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Table, TableHeader, ContextMenu, TableLoading, Colors } from 'advenio-components'

var Container = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 15px;
`

var CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: normal;
  height: 60px;
  color: #637381;
  font-size: 14px;
  background-color: ${function (props) { return props.index % 2 ? Colors.gray200 : Colors.white300 }};
`

var NameCell = styled(CellContainer)`
  justify-content: flex-start;
  padding-left: 14px;
  cursor: pointer;
  color: ${Colors.blue500};
  &:hover {
    text-decoration: underline;
  }
`

var NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: #637381;
  font-size: 14px;
  background-color: #FFFFFF;
  border: 1px solid ${Colors.gray200};
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`

class DocumentsTable extends Component {
  formatMimeType = (mime) => {
    if (!mime) return '-'
    var map = {
      'application/pdf': 'PDF',
      'application/msword': 'Word',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word (DOCX)',
      'application/vnd.ms-excel': 'Excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel (XLSX)',
      'application/vnd.ms-powerpoint': 'PowerPoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PowerPoint (PPTX)',
      'image/jpeg': 'Imagen (JPG)',
      'image/png': 'Imagen (PNG)',
      'text/plain': 'Texto'
    }
    return map[mime] || mime
  }

  formatFileSize = (bytes) => {
    if (!bytes) return '0 B'
    var sizes = ['B', 'KB', 'MB', 'GB']
    var i = Math.floor(Math.log(bytes) / Math.log(1024))
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i]
  }

  onNavigate = (id) => {
    return function (event) {
      event.preventDefault()
      this.props.goToDocument(id)
    }.bind(this)
  }

  render () {
    var self = this
    var documents = this.props.documents
    var fetching = this.props.fetching
    var onDistribute = this.props.onDistribute

    if (fetching) {
      return (
        <Container>
          <TableLoading
            roundedCorners
            columns={[
              { id: 1, header: 'Nombre', element: 'Text' },
              { id: 2, header: 'Tipo', element: 'Text', width: '140px', center: true },
              { id: 3, header: 'Tamaño', element: 'Text', width: '100px', center: true },
              { id: 4, header: 'Versiones', element: 'Text', width: '110px', center: true },
              { id: 5, header: 'Fecha', element: 'Text', width: '130px', center: true },
              { id: 6, header: '', element: 'Text', width: '70px' },
            ]}
            rows={5}
          />
        </Container>
      )
    }

    if (!documents || documents.length === 0) {
      return (
        <Container>
          <Table
            curvedBottom
            withBorder
            roundedCorners
            data={[{ id: 'empty' }]}
            columns={[
              {
                Header: function () { return <TableHeader blue title='Nombre' /> },
                id: 'name',
                accessor: function () { return null },
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Tipo' /> },
                id: 'mime_type',
                accessor: function () { return null },
                width: 140,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Tamaño' /> },
                id: 'file_size',
                accessor: function () { return null },
                width: 100,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Versiones' /> },
                id: 'version_count',
                accessor: function () { return null },
                width: 120,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Fecha' /> },
                id: 'created_at',
                accessor: function () { return null },
                width: 130,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue /> },
                id: 'actions',
                accessor: function () { return null },
                width: 70,
                Cell: function () { return null }
              }
            ]}
          />
          <NoResults>No hay documentos disponibles</NoResults>
        </Container>
      )
    }

    return (
      <Container>
        <Table
          curvedBottom
          withBorder
          roundedCorners
          data={documents}
          columns={[
            {
              Header: function () { return <TableHeader blue title='Nombre' /> },
              id: 'name',
              accessor: function (row) { return { id: row.id, name: row.name } },
              Cell: function (props) {
                return (
                  <NameCell index={props.index} onClick={self.onNavigate(props.value.id)}>
                    {props.value.name}
                  </NameCell>
                )
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Tipo' /> },
              id: 'mime_type',
              accessor: 'mime_type',
              width: 140,
              Cell: function (props) {
                return <CellContainer index={props.index}>{self.formatMimeType(props.value)}</CellContainer>
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Tamaño' /> },
              id: 'file_size',
              accessor: 'file_size',
              width: 100,
              Cell: function (props) {
                return <CellContainer index={props.index}>{self.formatFileSize(props.value)}</CellContainer>
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Versiones' /> },
              id: 'version_count',
              accessor: 'version_count',
              width: 110,
              Cell: function (props) {
                return <CellContainer index={props.index}>{props.value}</CellContainer>
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Fecha' /> },
              id: 'created_at',
              accessor: 'created_at',
              width: 130,
              Cell: function (props) {
                return (
                  <CellContainer index={props.index}>
                    {props.value ? new Date(props.value).toLocaleDateString('es-MX') : '-'}
                  </CellContainer>
                )
              }
            },
            {
              Header: function () { return <TableHeader blue /> },
              id: 'actions',
              accessor: function (row) { return { id: row.id, name: row.name } },
              width: 70,
              Cell: function (props) {
                return (
                  <CellContainer index={props.index}>
                    <ContextMenu
                      value={props.value.id}
                      elements={[
                        {
                          id: 1,
                          icon: 'eye',
                          label: 'Ver detalle',
                          onClick: function () { self.props.goToDocument(props.value.id) }
                        },
                        {
                          id: 2,
                          icon: 'send',
                          label: 'Distribuir',
                          onClick: function () { onDistribute(props.value.id) }
                        }
                      ]}
                    />
                  </CellContainer>
                )
              }
            }
          ]}
        />
      </Container>
    )
  }
}

DocumentsTable.propTypes = {
  documents: PropTypes.array,
  fetching: PropTypes.bool,
  goToDocument: PropTypes.func.isRequired,
  onDistribute: PropTypes.func
}

DocumentsTable.defaultProps = {
  documents: [],
  fetching: false,
  onDistribute: function () {}
}

var mapDispatchToProps = function (dispatch) {
  return {
    goToDocument: function (id) { return dispatch(push('/documents/' + id)) }
  }
}

export default connect(null, mapDispatchToProps)(DocumentsTable)



// WEBPACK FOOTER //
// ./src/Containers/Documents/DocumentLibrary/components/DocumentsTable.jsx